import { Navigate, useParams } from 'react-router';
import { useWorkspaceHref } from '@/features/workspace/WorkspaceDataSourceContext';
/**
 * Прежний адрес карточки сервиса портала /data-catalog/assets/:id/:tab?/:details_with?/
 * :flow_direction? — ссылки в старых событиях и закладках (спецификация :78: старые адреса
 * сохраняются). Ведёт на ту же карточку, вкладку и поток, а не в список.
 */
import { isEntityId, parseEntityId } from '@/lib/entityId';
import {
	flowDetailPath,
	servicePath,
	serviceTabOf,
	SERVICE_TABS,
	SERVICES_PATH,
} from './serviceRoutes';

export function LegacyAssetRedirect() {
	const href = useWorkspaceHref();
	const { id, tab, detailsWith, flowDirection } = useParams();
	const serviceId = parseEntityId(id) ?? 0;
	if (!isEntityId(serviceId)) return <Navigate to={href(SERVICES_PATH)} replace />;
	const target = serviceTabOf(tab);
	const interactsWith = parseEntityId(detailsWith) ?? 0;
	const to =
		target === SERVICE_TABS.flows && isEntityId(interactsWith)
			? flowDetailPath(
					serviceId,
					interactsWith,
					flowDirection === 'receiver' || flowDirection === 'sender' || flowDirection === 'both'
						? flowDirection
						: null,
				)
			: servicePath(serviceId, target);
	return <Navigate to={href(to)} replace />;
}
